import React, { ReactNode } from 'react'
import { TopToolbar } from '~m/designSystem'
import { useGlobalDialog } from '~m/AppUi/context'
import styles from './SecondaryLayoutWithActions.module.css'
import { ErrorBoundary } from '~m/AppUi/components/ErrorBoundary.tsx'
import cx from 'classnames'

interface SecondaryLayoutWithActionsProps {
  className?: string
  heading: string
  toolbar?: ReactNode
  actionsDrawer: ReactNode
  hasContentPadding?: boolean
  disableGlobalSearch?: boolean
}

export function SecondaryLayoutWithActions({
  className,
  heading,
  toolbar,
  actionsDrawer,
  hasContentPadding,
  disableGlobalSearch,
  children,
}: React.PropsWithChildren<SecondaryLayoutWithActionsProps>) {
  const { showGlobalDialog } = useGlobalDialog()
  return (
    <div
      className={cx(
        styles.SecondaryLayoutWithActions,
        className
      )}
    >
      <div
        className={
          styles.SecondaryLayoutWithActions__centerPanel
        }
      >
        <TopToolbar
          heading={heading}
          onSearch={
            disableGlobalSearch
              ? undefined
              : () => showGlobalDialog('search')
          }
        >
          {toolbar}
        </TopToolbar>
        <div
          className={cx(
            styles.SecondaryLayoutWithActions__content,
            {
              [styles.SecondaryLayoutWithActions__contentHasPadding]:
                hasContentPadding,
            }
          )}
        >
          <ErrorBoundary>{children}</ErrorBoundary>
        </div>
      </div>
      <ErrorBoundary>{actionsDrawer}</ErrorBoundary>
    </div>
  )
}
